angular.module('olivioConfiguratorApp')
  .controller('HeaderCtrl', function ($scope, $route) {
    //console.log('init HeaderCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.$route = $route;
  });
